import { render, staticRenderFns } from "./modalCancelandoAmostra.vue?vue&type=template&id=7990d818"
import script from "./modalCancelandoAmostra.vue?vue&type=script&lang=js"
export * from "./modalCancelandoAmostra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports